const defaultHost = process.env.REACT_APP_API_SERVER_PATH;
export const getZoomSignature = defaultHost + "/eu/zoom/get_zoom_details";
